import React from 'react';
import { TReportSection } from '@@config/report';
import Description from '@@components/Description/Description';
import Disclaimer from '@@components/Disclaimer/Disclaimer';
import GridTableHeader from '@@components/GridTableHeader/GridTableHeader';
import List from '@@components/List/List';
import ReportTypeHeader from '@@components/ReportTypeHeader/ReportTypeHeader.tsx';
import StructuredGridTable from '@@components/StructuredGridTable/StructuredGridTable';

type TSectionRendererProps = {
    section: TReportSection;
};

// Component factory function
const SectionRenderer: React.FC<TSectionRendererProps> = ({ section }) => {
    switch (section.SECTION_TYPE) {
        case 'hero':
            return (
                <div className='section section-hero w-full'>
                    <ReportTypeHeader title={section.SECTION_TITLE} />
                </div>
            );
        case 'table':
            return (
                <div className='section section-table'>
                    <GridTableHeader title={section.SECTION_TITLE} />
                    <StructuredGridTable section={section} />
                </div>
            );
        case 'list':
            return (
                <div className='section section-list'>
                    <List title={section.SECTION_TITLE} items={section.ITEMS!} />
                </div>
            );
        case 'description':
            return (
                <div className='section section-description'>
                    <Description title={section.SECTION_TITLE} items={section.ITEMS!} />
                </div>
            );
        case 'disclaimer':
            return (
                <div className='section section-disclaimer'>
                    <Disclaimer title={section.SECTION_TITLE} items={section.ITEMS!} />
                </div>
            );
        case 'multi-table':
            return (
                <div className='section section-multi-table hidden'>
                    <code>&lt;MultiTable/&gt;</code>
                    <h5 className='letter-spacing-normal'>{section.SECTION_TITLE}</h5>
                </div>
            );
        default:
            console.warn(`Unknown section type: ${section.SECTION_TYPE}`);
            return (
                <div className='section unknown-section hidden'>
                    <h3>{section.SECTION_TITLE}</h3>
                    <p>Unknown section type: {section.SECTION_TYPE}</p>
                </div>
            );
    }
};

export type { TSectionRendererProps };
export default SectionRenderer;
